import React from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Calendar, MapPin, ArrowRight } from 'lucide-react';

export const FamTripHubPage = () => {
  const famTrips = [
    {
      id: 'bhutan-druk-wangyel-festival-2026',
      destination: 'Bhutan',
      title: 'Druk Wangyel Festival Bhutan Famtrip',
      dates: '11–17 December 2026',
      duration: '7 Days / 6 Nights',
      description: 'A professional familiarization journey centered around Bhutan Druk Wangyel Festival, combining cultural experiences, destination discovery and first-hand travel knowledge.',
      image: 'https://images.unsplash.com/photo-1581588344552-b92555010a4b?q=85&w=1200',
      url: '/famtrip/bhutan-druk-wangyel-festival-2026'
    }
  ];

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'var(--bg-primary)' }}>
      <Navigation />
      <WhatsAppButton />

      {/* Hero Section */}
      <section style={{
        minHeight: '60vh',
        backgroundImage: 'linear-gradient(to bottom, rgba(7, 13, 30, 0.8), rgba(7, 13, 30, 0.9)), url(https://images.unsplash.com/photo-1582095127899-1dfb05e4e32d?q=85&w=2000)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        position: 'relative'
      }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px', textAlign: 'center' }}>
          <p style={{
            color: '#FBBF24',
            fontSize: '14px',
            fontWeight: '600',
            letterSpacing: '2px',
            marginBottom: '16px',
            textTransform: 'uppercase'
          }}>
            For Travel Professionals
          </p>
          
          <h1 style={{
            fontSize: 'clamp(40px, 5vw, 64px)',
            fontWeight: '300',
            lineHeight: '1.2',
            color: 'var(--text-primary)',
            marginBottom: '24px',
            fontFamily: 'Crimson Text, serif'
          }}>
            B2B Famtrip
          </h1>
          
          <p style={{
            fontSize: '20px',
            color: 'var(--text-secondary)',
            maxWidth: '800px',
            margin: '0 auto 32px',
            lineHeight: '1.6'
          }}>
            Discover curated familiarization trips designed for travel industry professionals, destination specialists, travel creators and travel media.
          </p>
        </div>
      </section>

      {/* Available FAM Trips Section */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
          <h2 style={{
            fontSize: '36px',
            fontWeight: '300',
            textAlign: 'center',
            color: 'var(--text-primary)',
            marginBottom: '48px',
            fontFamily: 'Crimson Text, serif'
          }}>
            Current Opportunities
          </h2>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '32px' }}>
            {famTrips.map((trip) => (
              <Link
                key={trip.id}
                to={trip.url}
                style={{
                  background: 'var(--bg-primary)',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  textDecoration: 'none',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  border: '1px solid rgba(251, 191, 36, 0.1)',
                  display: 'block'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 12px 40px rgba(251, 191, 36, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                {/* Image */}
                <div style={{
                  height: '280px',
                  backgroundImage: `url(${trip.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  position: 'relative'
                }}>
                  <div style={{
                    position: 'absolute',
                    top: '16px',
                    left: '16px',
                    background: 'rgba(7, 13, 30, 0.9)',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    border: '1px solid #FBBF24'
                  }}>
                    <p style={{ color: '#FBBF24', fontSize: '12px', fontWeight: '600', letterSpacing: '1px' }}>
                      B2B FAMTRIP
                    </p>
                  </div>
                </div>

                {/* Content */}
                <div style={{ padding: '32px' }}>
                  <p style={{
                    color: '#FBBF24',
                    fontSize: '12px',
                    fontWeight: '600',
                    letterSpacing: '2px',
                    marginBottom: '12px',
                    textTransform: 'uppercase'
                  }}>
                    {trip.destination}
                  </p>

                  <h3 style={{
                    fontSize: '24px',
                    fontWeight: '400',
                    color: 'var(--text-primary)',
                    marginBottom: '16px',
                    fontFamily: 'Crimson Text, serif',
                    lineHeight: '1.3'
                  }}>
                    {trip.title}
                  </h3>

                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '16px',
                    marginBottom: '16px',
                    fontSize: '14px',
                    color: 'var(--text-secondary)'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <Calendar size={16} style={{ color: '#FBBF24' }} />
                      <span>{trip.dates}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <MapPin size={16} style={{ color: '#FBBF24' }} />
                      <span>{trip.duration}</span>
                    </div>
                  </div>

                  <p style={{
                    color: 'var(--text-secondary)',
                    lineHeight: '1.7',
                    marginBottom: '24px',
                    fontSize: '15px'
                  }}>
                    {trip.description}
                  </p>

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    color: '#FBBF24',
                    fontWeight: '500',
                    fontSize: '14px'
                  }}>
                    <span>VIEW FAMTRIP</span>
                    <ArrowRight size={18} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* For Travel Professionals Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container" style={{ maxWidth: '900px', margin: '0 auto', padding: '0 24px', textAlign: 'center' }}>
          <h2 style={{
            fontSize: '36px',
            fontWeight: '300',
            color: 'var(--text-primary)',
            marginBottom: '24px',
            fontFamily: 'Crimson Text, serif'
          }}>
            For Travel Industry Professionals
          </h2>
          
          <p style={{
            color: 'var(--text-secondary)',
            lineHeight: '1.8',
            marginBottom: '32px',
            fontSize: '17px'
          }}>
            Our B2B Famtrips provide travel agents, tour operators, travel advisors, DMCs, travel influencers, travel media, and destination specialists with first-hand destination knowledge, cultural immersion, and professional networking opportunities to confidently develop and promote authentic travel experiences for their clients.
          </p>

          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '16px',
            marginTop: '32px'
          }}>
            {[
              'Travel Agents',
              'Tour Operators',
              'Travel Advisors',
              'DMCs',
              'Travel Influencers',
              'Travel Media',
              'Destination Specialists'
            ].map((type, i) => (
              <span
                key={i}
                style={{
                  padding: '10px 20px',
                  background: 'rgba(251, 191, 36, 0.1)',
                  border: '1px solid rgba(251, 191, 36, 0.3)',
                  borderRadius: '4px',
                  color: 'var(--text-primary)',
                  fontSize: '14px'
                }}
              >
                {type}
              </span>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
